import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, isRef as _isRef } from "vue"

const _hoisted_1 = { class: "d-flex align-center justify-space-between" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h4", { class: "text-h4" }, "Реестр пунктов выдачи карт", -1)
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "v-data-table__tr" }
const _hoisted_5 = ["colspan"]

import { computed, ref } from 'vue'
import {
  AppAuthService,
  CardIssuePoint,
  cardIssuePointGetAddress,
  CardIssuePointOrderFields,
  CardIssuePointsService,
  MunicipalEntitiesService,
  MunicipalEntity,
  OrderDirection,
  Paging,
  Permissions,
  RoleType,
} from '@prodcard/core'
import { AdditionalOptsWorksheet } from '../interfaces'
import FilterBox, { SearchParams } from './FilterBox.vue'
import { Pagination } from '../../../../components'
import { createCtx, handleError, useWatcherSavedRef } from '../../../../helpers'
import { saveWorkbook } from '../../../../common'
import { useRouter } from 'vue-router'
import { Workbook } from 'exceljs'
import { uniq } from 'lodash'
import { createSheetCardIssuePoints } from './createSheetCardIssuePoints'
import { useAuthPermissions, usePaginator, Paginator } from '../../../../mixins'


export default /*#__PURE__*/_defineComponent({
  __name: 'CardIssuePointsListPage',
  props: {
    authService: {},
    cardIssuePointsService: {},
    municipalEntitiesService: {}
  },
  setup(__props: any) {

const props = __props;


const router = useRouter()
const { paginator, count, getPageCount, resetPage } = usePaginator('CardIssuePointsPaginator')

const cardIssuePoints = ref<CardIssuePoint[]>([])
const municipalEntities = ref<MunicipalEntity[]>([])
const loading = ref(false)
const loadingTableToDownload = ref(false)

const headers = [
  { title: '№', key: 'number', sortable: false },
  { title: 'Адрес/Комментарий', key: 'address', sortable: false },
  { title: 'Количество окон', key: 'windowsCount', sortable: false },
  { title: 'Контактный телефон', key: 'phone', sortable: false },
  { title: 'Режим работы', key: 'openingHours', sortable: false },
  { title: '', key: 'menu', width: '64', sortable: false },
]

const { currentMunicipalEntityId, hasPermissions, currentUserRole } = useAuthPermissions(props.authService)

const hasView = computed(() => hasPermissions(Permissions.CARD_ISSUE_POINTS_VIEW))
const hasMeView = computed(() => hasPermissions(Permissions.ME_CARD_ISSUE_POINTS_VIEW))
const hasManage = computed(
  () =>
    (hasPermissions(Permissions.CARD_ISSUE_POINTS_MANAGE) || hasPermissions(Permissions.ME_CARD_ISSUE_POINTS_ADD)) &&
    currentUserRole.value?.type !== RoleType.OPERATOR,
)

const searchParams = useWatcherSavedRef<SearchParams>('CardIssuePointListParams', {
  search: '',
  municipalEntityId: hasMeView.value && !hasView.value ? currentMunicipalEntityId.value : undefined,
})

const update = (paginator: Paginator, filter: SearchParams) => {
  handleError(async () => {
    const from = (paginator.page - 1) * paginator.per
    const { resCardIssuePoints, resMunicipalEntities } = await fetchData(filter, { from: from, count: paginator.per })

    cardIssuePoints.value = resCardIssuePoints.items
    municipalEntities.value = resMunicipalEntities.items
    count.value = resCardIssuePoints.total
  }, loading)
}

const fetchData = async (filter: SearchParams, paging?: Paging) => {
  const ctx = createCtx()
  const resCardIssuePoints = await props.cardIssuePointsService.findAll(ctx, {
    paging,
    filter,
    order: { field: CardIssuePointOrderFields.NUMBER, direction: OrderDirection.ASC },
  })

  const resMunicipalEntities = await props.municipalEntitiesService.findAll(ctx, {
    filter: { ids: uniq(resCardIssuePoints.items.map(cip => cip.municipalEntityId)) },
  })

  return { resCardIssuePoints, resMunicipalEntities }
}

const updateSearchParams = (sp: SearchParams) => {
  resetPage()
  searchParams.value = sp
  update(paginator.value, searchParams.value)
}

const openDetails = async (e: Event, val: { item: { value: string } }) => {
  if (hasManage.value) {
    await router?.push('/card-issue-points/' + val.item.value + '/edit')
  }
}

const downloadTable = (filter: SearchParams) => {
  handleError(async () => {
    const workbook = new Workbook()
    const { resCardIssuePoints, resMunicipalEntities } = await fetchData(filter, {})

    const opts: AdditionalOptsWorksheet = {
      count: resCardIssuePoints.count,
      cardIssuePoints: resCardIssuePoints.items,
      municipalEntities: resMunicipalEntities.items,
    }
    createSheetCardIssuePoints(workbook, 'Реестр пунктов выдачи карт', opts)

    await saveWorkbook(workbook, 'Реестр_пунктов_выдачи_карт')
  }, loadingTableToDownload)
}

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_data_table_server = _resolveComponent("v-data-table-server")!

  return (_openBlock(), _createBlock(_component_v_data_table_server, {
    headers: headers,
    loading: loading.value,
    items: cardIssuePoints.value,
    "items-length": _unref(count),
    "no-data-text": "Нет данных",
    hover: "",
    "onUpdate:options": _cache[3] || (_cache[3] = ($event: any) => (update(_unref(paginator), _unref(searchParams)))),
    "onClick:row": openDetails
  }, {
    top: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        (hasManage.value)
          ? (_openBlock(), _createBlock(_component_v_btn, {
              key: 0,
              to: "/card-issue-points/new",
              color: "primary"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Создать")
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _createVNode(FilterBox, {
        class: "my-5",
        "municipal-entities-service": _ctx.municipalEntitiesService,
        "default-search-params": _unref(searchParams),
        loading: loading.value,
        "readonly-me": hasMeView.value && !hasView.value,
        onUpdate: updateSearchParams
      }, null, 8, ["municipal-entities-service", "default-search-params", "loading", "readonly-me"])
    ]),
    "item.number": _withCtx(({ item }) => [
      _createTextVNode(_toDisplayString(municipalEntities.value.find(me => me.id === item.raw.municipalEntityId)?.index) + "." + _toDisplayString(item.raw.number), 1)
    ]),
    "item.address": _withCtx(({ item }) => [
      _createElementVNode("p", null, [
        _createTextVNode(_toDisplayString(_unref(cardIssuePointGetAddress)(item.raw)) + " ", 1),
        (item.raw.comment)
          ? (_openBlock(), _createBlock(_component_v_tooltip, {
              key: 0,
              text: item.raw.comment,
              activator: "parent",
              location: "top left",
              "max-width": "350px"
            }, null, 8, ["text"]))
          : _createCommentVNode("", true)
      ])
    ]),
    tfoot: _withCtx(() => [
      (_unref(count))
        ? (_openBlock(), _createElementBlock("tfoot", _hoisted_3, [
            _createElementVNode("tr", _hoisted_4, [
              _createElementVNode("td", {
                colspan: headers.length,
                class: "v-data-table__td text-right"
              }, [
                _createTextVNode(" Итого: "),
                _createElementVNode("b", null, _toDisplayString(_unref(count)), 1)
              ], 8, _hoisted_5)
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    bottom: _withCtx(() => [
      _createVNode(_unref(Pagination), {
        modelValue: _unref(paginator),
        "onUpdate:modelValue": [
          _cache[0] || (_cache[0] = ($event: any) => (_isRef(paginator) ? (paginator).value = $event : null)),
          _cache[1] || (_cache[1] = ($event: any) => (update($event, _unref(searchParams))))
        ],
        "page-count": _unref(getPageCount),
        disabled: loading.value || _unref(getPageCount) === 0,
        class: "mt-5"
      }, null, 8, ["modelValue", "page-count", "disabled"]),
      (_unref(hasPermissions)(_unref(Permissions).CARD_ISSUE_POINTS_TABLE_EXPORT))
        ? (_openBlock(), _createBlock(_component_v_btn, {
            key: 0,
            class: "mt-5",
            color: "primary",
            variant: "outlined",
            "prepend-icon": "mdi-download-outline",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (downloadTable(_unref(searchParams)))),
            loading: loadingTableToDownload.value,
            disabled: loading.value
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Скачать ")
            ]),
            _: 1
          }, 8, ["loading", "disabled"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["loading", "items", "items-length"]))
}
}

})